import { render, staticRenderFns } from "./DrawerView.vue?vue&type=template&id=2ef5816f&"
import script from "./DrawerView.vue?vue&type=script&lang=js&"
export * from "./DrawerView.vue?vue&type=script&lang=js&"
import style0 from "./DrawerView.vue?vue&type=style&index=0&id=2ef5816f&prod&scope=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports